<template>
  <div id="data-table" class="container-fluid" :style="[seen ? { '': '' } : { 'height': '44px' }]"
    :class="{ transparent: !seen }">
    <div class="row text-center" :class="{ transparent: true }"><button class="oc-button"
        v-on:click="seen = !seen">Ocultar/Mostrar</button></div>
    <div class="row" id="main-row" v-if="seen">
      <div id="alarmas" class="col">
        <div class="panel panel-default">
          <div class="panel-heading text-center">
            <h3 class="panel-title">
              <span id="no-reconocidas" @click="recAlarm(0)"> Alarmas No Reconocidas </span>
              <span id="reconocidas" class="not-active" @click="recAlarm(1)"> Alarmas Reconocidas </span>
              <!-- <span id="operational" class="not-active" @click="recAlarm(2)"> Movimientos operativos </span> -->
            </h3>
          </div>
          <div class="panel-body">
            <table class="table">
              <thead>
                <tr class="text-center">
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>
                    Fecha<i class="fa fa-angle-down" aria-hidden="true"></i>
                  </th>
                  <th>Estado</th>
                  <th>Ciudad</th>
                  <th>Latitud</th>
                  <th>Longitud</th>
                  <th>Km</th>
                  <th>Tramo</th>
                  <th>Tipo</th>
                  <th>Presión</th>
                  <th v-if="alarmIndex === 1">Reconocimiento</th>
                  <th v-if="alarmIndex === 1">Usuario</th>
                </tr>
              </thead>
              <tbody v-for="(group, sectionName) in groupedLeaks" :key="sectionName">
                <tr>
                  <td class="nombre-alarma" :colspan="alarmIndex === 1 ? 16 : 14">Ducto: {{ sectionName }}</td>
                </tr>
                <tr v-for="leak in group" :key="leak.id" :class="['info']" :id="`${leak.id}-trAlarmaH`"
                  @click="leakClicked(leak)">
                  <td>
                    <router-link :to="{ path: 'historico/' + leak.id }" target="_blank">Abrir</router-link>
                  </td>
                  <td class="table-option">
                    <button v-if="isAllowedToIdentifyLeak" @click="identifyLeak(leak)" title="Identificar fuga">
                      <i class="fa fa-check-square-o identify-leak" aria-hidden="true"></i>
                    </button>
                    <button v-if="!isAllowedToIdentifyLeak" @click="leakClicked(leak)" title="Ver fuga">
                      <i class="fa fa-eye open-leak" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td class="table-option" :title="getLeakDescription(leak)">
                    <i :class="getIcon(leak)" :style="getColor(leak)" aria-hidden="true"></i>
                  </td>
                  <td class="table-option">
                    <button @click="locateLeak(leak)" title="Ubicar fuga">
                      <i class="fa fa-map-marker" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td class="table-option">
                    <div hidden><input type="text" :id="`clipboard_${leak.id}`" :value="clipboardText(leak)"></div>
                    <button @click="copyToClipboardClick(`clipboard_${leak.id}`)" title="Copiar al porta papeles">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td colspan="1">{{ leak.formattedDetectionTimestamp || 'No Timestamp Available' }}</td>
                  <td>{{ leak.states }}</td>
                  <td>{{ leak.cities }}</td>
                  <td>{{ leak.lat }}</td>
                  <td>{{ leak.lon }}</td>
                  <td>{{ leak.km }}</td>
                  <td>{{ leak.formattedSiteName }}</td>
                  <td>{{ (Number(leak._type) <= 1 ? 'Apertura' : 'Cierre') }}</td>
                  <td>{{ leak.pressure_1 + ' kg/cm2 - ' + leak.pressure_2 + ' kg/cm2' }} </td>
                  <td v-if="alarmIndex === 1">{{ leak.recognized_timestamp }}</td>
                  <td v-if="alarmIndex === 1">{{ leak.recognized_username }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <modal name="comentario">
      <div class="modal-body row">
        <!-- content goes here -->
        <h5 class="modal-title text-uppercase" id="lineModalLabel" style="padding: 15px;">Ubicación en el mapa</h5>
        <form>
          <div class="form-group col-sm-6">
            <label id="label-name" for="comentarios">a</label>
            <input type="email" class="form-control" id="comentarios" v-model="comentario"
              placeholder="Haz un comentario">
          </div>
          <div class="form-group col-sm-6">
            <label for="selectDonde">Elige un concepto</label>
            <br>
            <select name="selectDonde" id="selectDonde" v-model="selected">
              <option disabled value="" class="disabled">Please select one</option>
              <option v-for="(val, key, index) in conceptos" :key="key" :value="val.value"> {{ val.name }} </option>
            </select>
          </div>
          <!-- <div class="form-group col-sm-12">
            <label id="label-name" for="comentarios"></label>
            <input type="email" class="form-control" id="comentarios" placeholder="Haz un comentario">
          </div>-->
        </form>

      </div>
      <div class="modal-footer">
        <div class="btn-group btn-group-justified" role="group" aria-label="group button">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-default waves-effect waves-light" data-dismiss="modal"
              role="button">Close</button>
          </div>
          <div class="btn-group btn-delete hidden" role="group">
            <button type="button" id="delImage" class="btn btn-default waves-effect waves-light" data-dismiss="modal"
              role="button">Cancelar</button>
          </div>
          <div class="btn-group" role="group">
            <button type="submit" :class="[(comentario === '' || selected === '') ? 'disabled' : '']" id="saveImage"
              @click="postBitacora()" class="btn btn-default waves-effect waves-light" data-action="save"
              role="button">Guardar</button>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import Vue from 'vue'
import Modal from 'reusable/Modal'
import toastr from 'toastr'
import Leak from '../../models/leak'
import { get } from 'jquery'
var $ = require('jquery')
export default {
  props: {
    parentRefs: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      seen: true,
      conceptos: [],
      selected: '',
      comentario: '',
      dbSize: 0,
      ducto: '',
      ductoActivo: {},
      tempInterval: '',
      ducts: '',
      leaks: '',
      filtAlarms: '',
      interval: null,
      mapComp: this.parentRefs.map,
      alarmIndex: 0,
      isAllowedToIdentifyLeak: false,
    }
  },
  computed: {
  /**
   * Groups the filtered alarms by the first section name (_name_section_1) and sorts the groups alphabetically by the section name.
   * 
   * The function performs the following steps:
   * 1. Checks if `filtAlarms` is available. If not, returns an empty object.
   * 2. Reduces the `filtAlarms` array to an object (`grouped`) where:
   *    - Leaks with status < 2 are included only if `alarmIndex` is 0 (unrecognized alarms).
   *    - Leaks with status >= 2 are included only if `alarmIndex` is 1 (recognized alarms).
   *    - Leaks with is_operational_movement === true are included.
   *    - Leaks are grouped by their `_name_section_1` property.
   * 3. Sorts the keys of the `grouped` object alphabetically.
   * 4. Returns the sorted object.
   */
  groupedLeaks() {
      if (!this.filtAlarms) return {}

      const grouped = this.filtAlarms.reduce((acc, leak) => {
        // Include operational movements only when alarmIndex is 2
        if (this.alarmIndex === 2 && !leak.is_operational_movement) return acc;

        // Include unrecognized alarms only when alarmIndex is 0
        if (this.alarmIndex === 0 && (leak.status >= 2 || leak.is_operational_movement)) return acc;

        // Include recognized alarms only when alarmIndex is 1
        if (this.alarmIndex === 1 && (leak.status < 2 || leak.is_operational_movement)) return acc;

        // Group leaks by their `_name_section_1` property
        if (!acc[leak._name_section_1]) {
          acc[leak._name_section_1] = [];
        }
        acc[leak._name_section_1].push(leak);
        return acc;
      }, {});

      // Sort the groups alphabetically
      return Object.fromEntries(Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b)));
    },
  },
  methods: {
    whenClicked: function () {
      this.active = !this.active
    },
    clipboardText: function (leak) {
      // Ducto, tramo, kilometro, coordenadas, fecha, hora
      // return "Ducto: " + name + ", Tramo: " + leak.formattedSiteName;
      var datetime = leak.formattedDetectionTimestamp.split(' ');
      return `${leak.formattedSectionName}, ${leak.formattedSiteName}, ${leak.km}, ${leak.lat}, ${leak.lon}, ${datetime[0]}, ${datetime[1]}`;
    },
    copyToClipboardClick(clipboard_id) {
      // console.log('clipboard_id : ' + clipboard_id);
      var copyText = $('#' + clipboard_id);
      // console.log(copyText.val());

      var $temp = $('<input>');
      $('body').append($temp);
      $temp.val(copyText.val()).select();

      /* Copy the text inside the text field */
      document.execCommand('copy');
      $temp.remove();
    },
    locateLeak(leak) {
      this.mapComp.onLocateLeak(leak);
    },
    identifyLeak(leak) {
      this.mapComp.onIdentifyLeak(leak, (result) => {
        result.status = Leak.Status.RECOGNIZED;
      });
    },
    postBitacora() {
      if (this.comentario === '' || this.selected === '') {
        return
      }

      let user = Vue.ls.get('user')
      this.$store.dispatch('POST_BITACORA', {
        username: user.username,
        id_section: this.ducto,
        id_concept: this.selected,
        comment: this.comentario,
      }).then(resp => {
        toastr.success('Se a añadido exitosamente tu comentario !')
        this.comentario = ''
        this.selected = ''
      }).catch(err => {
        toastr.error('Hubo un error, Favor de volver a intentarlo')
        console.log('Error', err)
      })
    },
    recFilter() {
      this.filtAlarms = this.$store.getters.GET_HOME_LEAKS_TABLE
      // console.log(this.filtAlarms);
    },
    setMap(sectionId, site) {
      this.mapComp.onSiteTableClicked(sectionId, site)
    },
    leakClicked(leakId) {
      this.mapComp.onLeakTableClicked(leakId);
    },
    recAlarm(t) {
      this.alarmIndex = t
      if(t === 2) {
        $('tr.reconocidas').hide()
        $('tr.no-reconocidas').hide()
        $('tr.operational').show()

        $('#operational').removeClass('not-active')
        $('#no-reconocidas').addClass('not-active')
        $('#reconocidas').addClass('not-active')
      } else if (t === 1) {
        $('tr.reconocidas').show()
        $('tr.no-reconocidas').hide()
        $('tr.operational').hide()

        $('#operational').addClass('not-active')
        $('#no-reconocidas').addClass('not-active')
        $('#reconocidas').removeClass('not-active')      
      } else {
        $('tr.reconocidas').hide()
        $('tr.no-reconocidas').show()
        $('tr.operational').hide()

        $('#operational').addClass('not-active')
        $('#no-reconocidas').removeClass('not-active')
        $('#reconocidas').addClass('not-active')
      }
    },
    getLeakDescription(leak) {
      if(leak.is_operational_movement === true) {
        return 'Movimiento operativo'
      }
      if(leak.offline_status) {
        return 'Fuga reconocida'
      }
      return 'Fuga no reconocida'
    },
    getColor(leak) {
      if(leak.is_operational_movement === true) {
        return 'color: orange'
      }
      if(leak.offline_status) {
        return 'color: red'
      }
      return 'color: green'
    },
    getIcon(leak){
      if(leak.is_operational_movement === true) {
        return 'fa fa-cogs'
      }
      if(leak.offline_status) {
        return 'fa fa-chain-broken'
      }
      return 'fa fa-bolt'
    },
    showDucto(id) {
      $(`.${id}`).toggleClass('no-show')
    },
    passName(leak) {
      this.ducto = Object.keys(this.ducts).filter(duc => {
        return leak._name_section_1 === this.ducts[duc]._name
      })
      $('#label-name').text('Ducto: ' + leak._name_section_1)
    },
    fillData() {
      this.ducts = this.$store.getters.GET_HOME_DUCTOS_TABLE
    },
    fillLeaks() {
      this.recFilter()
    }
  },
  updated() {
    this.recAlarm(this.alarmIndex)
  },
  mounted() {
    let user = Vue.ls.get('user');
    this.isAllowedToIdentifyLeak = user.userPermissions && user.userPermissions.includes('Alertas')
    this.$store.dispatch('LOAD_CONCEPTOS')
      .then(resp => {
        resp.data.forEach(con => {
          this.conceptos.push({
            name: con.name,
            value: con.id_journal_concept
          })
        })
      }).catch(err => {
        console.log('Error', err)
      })
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.panel {
  margin-bottom: 0;
}

td {
  cursor: pointer;
}

.isHidden {
  display: none;
}

.transparent {
  pointer-events: none;
}

.oc-button {
  pointer-events: auto;
  background-color: $amarilloC;
  color: white;
  padding: 10px;
  margin: 0 10px;
  display: inline-block;
  position: relative;
  border-radius: 1px solid #333;
}

.oc-button:active {
  background-color: #333;
  color: white;
}

.row {
  margin-right: -30px;
}

.no-show {
  display: none;
}

h3 {
  color: black;
  cursor: pointer;
}

span {
  padding: 0 20px;

  @include cMax(400px) {
    padding: 0 10px;
  }
}

table,
.panel-body {
  background-color: $bg;
  overflow: scroll;
  height: 100%;
  padding: 0;
  padding-left: 15px;
}

table {
  height: 35vh;
}

.not-active {
  color: $inactive;
}

.col-md-5,
.col-md-7 {
  margin: 0;
  padding: 0;
}

.panel-default {
  background-color: $gray;
  border: none;
  border-radius: 0;
}

#data-table {
  position: absolute;
  color: $titles;
  width: 100vw;
  height: 50vh;
  bottom: 0;
  padding-left: 30px;
}

#ductos {
  h3 {
    padding-left: 15px;
  }

  .ducto {
    color: white;
    font-size: 12px;
    cursor: pointer;
    background-color: $amarilloC;
  }
}

#alarmas {
  th {
    text-align: left;

    @include cMax(415px) {
      font-size: 12px;
    }
  }

  td {
    text-align: left;
    background-color: $bg;
    cursor: pointer;

    &.table-option {
      padding: 8px 1px;
      & button {
        border-width: 0px;
        margin: 0px;
        padding: 0px 4px;
      }
    }

    tr {
      cursor: pointer;
    }

    i {
      color: $inactive;
      cursor: pointer;

      &:hover {
        color: $amarilloC;
      }

      &.identify-leak {
        color: var(--md-theme-default-primary);
        font-size: 16px;
      }


      &.open-leak {
        color: var(--md-theme-default-primary);
        font-size: 16px;
      }
    }
  }

  .nombre-alarma {
    height: 40px;
    background-color: $amarilloC;
    color: white;
  }

  .info {
    // border: 1px solid red;
  }

  .panel-body {
    padding: 0;
  }

  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}

#comentario-modal {
  h3 {
    color: $titles;
  }

  .btn-default {
    background-color: $amarilloC;

    &:hover,
    &:active,
    &:focus {
      background-color: $amarilloO !important;
    }
  }

  label {
    color: $amarilloC;
  }

  #label-name {
    color: white;
    width: 100%;
    font-size: 16px;
    padding: 5px;
    background-color: $amarilloC;
  }

  #selectDonde {
    -webkit-appearance: none;
    -webkit-border-radius: 0px;
    width: 80%;
    height: 40px;
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// DataTable.vue?7d0e05e9